export const customDarkSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#2c2c2c',
        borderColor: state.isFocused ? '#555' : '#444',
        boxShadow: 'none',
        color: '#f1f1f1',
        minHeight: '40px',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            borderColor: '#666',
            backgroundColor: '#333',
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#2c2c2c',
        color: '#f1f1f1',
        zIndex: 999,
    }),
    option: (provided, state) => ({
        ...provided,
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 10px',
        backgroundColor: state.isSelected
            ? '#1e88e5'
            : state.isFocused
                ? '#3a3a3a'
                : '#2c2c2c',
        color: state.isSelected ? '#fff' : '#f1f1f1',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease-in-out',
        '&:hover': {
            backgroundColor: '#4a4a4a',
        },
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#f1f1f1',
    }),
    input: (provided) => ({
        ...provided,
        color: '#f1f1f1',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#999',
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#444',
        color: '#f1f1f1',
        transition: 'background-color 0.2s ease-in-out',
        '&:hover': {
            backgroundColor: '#555',
        },
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#f1f1f1',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#ccc',
        transition: 'all 0.2s ease-in-out',
        ':hover': {
            backgroundColor: '#666',
            color: '#fff',
        },
    }),
};
